import React from "react";
import Main from "./Pages/Main";

import { BrowserRouter, Switch, Routes, Route } from "react-router-dom";
import CallPage from "./Pages/CallPage";
import Room from "./Pages/Room";
import NoMatch from "./Pages/NoMatch";
import WhiteBoard from './components/container/WhiteBoard';
import Messanger from './components/Messanger';

function App() {
  return (
    
    <div>

          <Routes>
            <Route path="/" element={<Main />}></Route>
            <Route path="/room/:roomId" element={<Room />}></Route>
            {/* <Route exact path="/room/:roomId" element={<CallPage />}></Route> */}
            <Route path="*" element={<NoMatch/>}></Route>
            <Route path="/whiteboard/:roomId" element={<WhiteBoard/>} />
            {/* <Route path="/message" element={<Messanger/>} /> */}
          </Routes>

    </div>
  );
}

export default App;
